import { DatePickerField } from '@monorepo/shared/componentsV2/fields/DatePickerField';
import { DatetimePickerField } from '@monorepo/shared/componentsV2/fields/DatetimePickerField';
import {
  DatetimeValue,
  DateValue,
  FieldDataType,
  FieldResponse,
  NullableString,
  SaveDatetimeValue,
  SaveDateValue,
  UTCEquivalentOfLocal,
} from 'mapistry-shared';
import React, { useMemo } from 'react';
import { FormValues, isNullableDate } from './types';
import {
  dateFieldValueToFormInitialValue,
  getUnexpectedTypeErrorAndLogToSentry,
  getValidateFunction,
} from './utils';

type EditDateLikeFieldValueProps = {
  className?: string;
  field: FieldResponse;
  fieldValue?: DateValue | DatetimeValue;
  isRequired: boolean;
  label: string;
  name: string;
  subText?: NullableString;
  disabled?: boolean;
  isLabelHidden?: boolean;
  isErrorTextHidden?: boolean;
  isCompact?: boolean;
  isSubtextHidden?: boolean;
  forceShowErrors?: boolean;
};

export function EditDateLikeValueFactory({
  className,
  field,
  fieldValue,
  isRequired,
  label,
  name,
  subText,
  disabled,
  isLabelHidden,
  isErrorTextHidden,
  isCompact,
  isSubtextHidden,
  forceShowErrors,
}: EditDateLikeFieldValueProps) {
  const validate = getValidateFunction(isRequired);

  const transformedDateValue = useMemo(
    () => dateFieldValueToFormInitialValue(fieldValue),
    [fieldValue],
  );

  const props = {
    className,
    subText,
    label,
    name,
    initialValue: transformedDateValue,
    validate,
    required: isRequired,
    disabled,
    isLabelHidden,
    isErrorTextHidden,
    isCompact,
    isSubtextHidden,
    forceShowErrors,
  };

  return field.type === FieldDataType.DATE ? (
    <DatePickerField {...props} />
  ) : (
    <DatetimePickerField {...props} />
  );
}

export function getDateLikeFieldValueFromForm(
  field: FieldResponse,
  formValues: FormValues,
) {
  const value = formValues[field.id] || null;
  if (!isNullableDate(value)) {
    throw getUnexpectedTypeErrorAndLogToSentry(field, value);
  }
  const fieldValue: SaveDateValue | SaveDatetimeValue = {
    value: value ? UTCEquivalentOfLocal(value) : value,
  };
  return {
    fieldId: field.id,
    fieldValue,
  };
}
